import HomeIcon from "@mui/icons-material/Home";
import HandymanIcon from "@mui/icons-material/Handyman";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AssignmentIcon from "@mui/icons-material/Assignment";
import SettingsIcon from "@mui/icons-material/Settings";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import LockClockIcon from "@mui/icons-material/LockClock";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import SummarizeIcon from "@mui/icons-material/Summarize";
import PedalBikeIcon from "@mui/icons-material/PedalBike";
import UpdateIcon from "@mui/icons-material/Update";
import ApartmentIcon from "@mui/icons-material/Apartment";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import PublishIcon from "@mui/icons-material/Publish";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SavingsIcon from "@mui/icons-material/Savings";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import StorefrontIcon from "@mui/icons-material/Storefront";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import BusinessIcon from "@mui/icons-material/Business";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import PaidIcon from "@mui/icons-material/Paid";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import GarageIcon from "@mui/icons-material/Garage";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import PinDropIcon from "@mui/icons-material/PinDrop";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import MuseumIcon from "@mui/icons-material/Museum";
import TollIcon from "@mui/icons-material/Toll";
import NorthIcon from "@mui/icons-material/North";
import GavelIcon from "@mui/icons-material/Gavel";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import CommuteIcon from "@mui/icons-material/Commute";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import WaterIcon from "@mui/icons-material/Water";
import ForestIcon from "@mui/icons-material/Forest";
import WavesIcon from "@mui/icons-material/Waves";
import MultipleStopIcon from "@mui/icons-material/MultipleStop";
import ForkRightIcon from "@mui/icons-material/ForkRight";
import TerrainIcon from "@mui/icons-material/Terrain";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import SailingIcon from "@mui/icons-material/Sailing";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import GridViewIcon from "@mui/icons-material/GridView";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PaletteIcon from "@mui/icons-material/Palette";
import Looks3Icon from "@mui/icons-material/Looks3";
import PublicIcon from "@mui/icons-material/Public";
import FlagIcon from "@mui/icons-material/Flag";
import MapIcon from "@mui/icons-material/Map";
import ExploreIcon from "@mui/icons-material/Explore";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import SouthIcon from "@mui/icons-material/South";
import ParkIcon from "@mui/icons-material/Park";
import LandscapeTwoToneIcon from "@mui/icons-material/LandscapeTwoTone";
import HikingIcon from "@mui/icons-material/Hiking";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import WbTwilightIcon from "@mui/icons-material/WbTwilight";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import SubwayIcon from "@mui/icons-material/Subway";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import SpeedIcon from "@mui/icons-material/Speed";
import GrassIcon from "@mui/icons-material/Grass";
import NatureIcon from "@mui/icons-material/Nature";
import StreamIcon from "@mui/icons-material/Stream";
import RouteIcon from "@mui/icons-material/Route";
import BarChartIcon from "@mui/icons-material/BarChart";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PolicyIcon from "@mui/icons-material/Policy";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import RadarIcon from "@mui/icons-material/Radar";
import RouterIcon from "@mui/icons-material/Router";
import SensorsIcon from "@mui/icons-material/Sensors";
import VideocamIcon from "@mui/icons-material/Videocam";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import SyncIcon from "@mui/icons-material/Sync";
import ShieldIcon from "@mui/icons-material/Shield";
import PinIcon from "@mui/icons-material/Pin";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import StoreIcon from "@mui/icons-material/Store";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
import SecurityIcon from "@mui/icons-material/Security";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import LoginIcon from "@mui/icons-material/Login";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import Dashboard from "modules/dashboard";
import Indicadores from "modules/indicadores";
import SignIn from "modules/authentication/sign-in";
import SignUp from "modules/authentication/sign-up";
import Usuario from "modules/usuario";
import Rol from "modules/rol";
import Schedule from "modules/bitacora/agendamiento";
import Conciliacion from "modules/finops/conciliaciones/alianza/conciliacion";
import Holguines from "modules/finops/conciliaciones/alianza/holguines";
import Fundadores from "modules/finops/conciliaciones/alianza/fundadores";
import Vizcaya from "modules/finops/conciliaciones/alianza/vizcaya";
import Zpp from "modules/finops/conciliaciones/alianza/zpp";
import Chipichape from "modules/finops/conciliaciones/alianza/chipichape";
import Covipacifico from "modules/finops/conciliaciones/peajes/covipacifico";
import AlcaEnvigado from "modules/finops/conciliaciones/peajes/alcaEnvigado";
import Alma from "modules/finops/conciliaciones/peajes/alma";
import Covioriente from "modules/finops/conciliaciones/peajes/covioriente";
import Altviales from "modules/finops/conciliaciones/peajes/altviales";
import Accenorte from "modules/finops/conciliaciones/peajes/accenorte";
import Coviandina from "modules/finops/conciliaciones/peajes/coviandina";
import Autocafe from "modules/finops/conciliaciones/peajes/autocafe";
import AutoRioMagdalena from "modules/finops/conciliaciones/peajes/autoriomagdalena";
import AutNordeste from "modules/finops/conciliaciones/peajes/autnordeste";
import AutRioGrande from "modules/finops/conciliaciones/peajes/autriogrande";
import BtsConcesionario from "modules/finops/conciliaciones/peajes/btsconcesionario";
import AutoviaNeivaGirardot from "modules/finops/conciliaciones/peajes/autovianeivagirardot";
import Panamericana from "modules/finops/conciliaciones/peajes/panamericana";
import PacificoTres from "modules/finops/conciliaciones/peajes/pacificoTres";
import Pisa from "modules/finops/conciliaciones/peajes/pisa";
import RutaalMar from "modules/finops/conciliaciones/peajes/rutaalMar";
import Viadelosllanos from "modules/finops/conciliaciones/peajes/viadelosllanos";
import Devimar from "modules/finops/conciliaciones/peajes/devimar";
import Findeter from "modules/finops/conciliaciones/peajes/findeter";
import Devisab from "modules/finops/conciliaciones/peajes/devisab";
import Devimed from "modules/finops/conciliaciones/peajes/devimed";
import Via40Express from "modules/finops/conciliaciones/peajes/via40Express";

// 🆕 Nuevos íconos para Lazo y Tags

// Layouts
import JobOrder from "modules/bitacora/ordenesDeTrabajo";
import Configuracion from "modules/bitacora/configuracion";
import UnionDelSur from "modules/finops/conciliaciones/peajes/uniondelsur";
import ViaDelNus from "modules/finops/conciliaciones/peajes/viadelnus";
import SabanaOcc from "modules/finops/conciliaciones/peajes/sabanaocc";
import LaPintada from "modules/finops/conciliaciones/peajes/lapintada";
import Iccu from "modules/finops/conciliaciones/peajes/iccu";
import PeajesNacionales from "modules/finops/conciliaciones/peajes/peajesNacionales";
import Yuma from "modules/finops/conciliaciones/peajes/yuma";
import RutaDelCacao from "modules/finops/conciliaciones/peajes/rutadelcacao";
import RutaDelValle from "modules/finops/conciliaciones/peajes/rutadelvalle";
import RutaMSierraMar from "modules/finops/conciliaciones/peajes/rutamsierramar";
import TunelDelOriente from "modules/finops/conciliaciones/peajes/tuneldeloriente";
import RutaPortuaria from "modules/finops/conciliaciones/peajes/rutaportuaria";
import AutopistaUraba from "modules/finops/conciliaciones/peajes/autopistauraba";
import Sisga from "modules/finops/conciliaciones/peajes/sisga";
import ViaMontesDeMaria from "modules/finops/conciliaciones/peajes/viamontesdemaria";
import ViaRioPamplonita from "modules/finops/conciliaciones/peajes/viariopamplonita";
import Pob from "modules/finops/conciliaciones/peajes/pob";
import RutaAlSur from "modules/finops/conciliaciones/peajes/rutaalsur";
import TableroSac from "modules/tableros/tableroSac";
import TableroGerencia from "modules/tableros/tableroGerencia";
import GestionConciliaciones from "modules/finops/conciliaciones/gestionConciliaciones";
import InfoConcesion from "modules/finops/infoConcesion";
import Redes from "modules/monitoreo/redes";
import Readers from "modules/monitoreo/readers";
import Cierre from "modules/came/cierre";
import CrearCiclo from "modules/monitoreo/creacionCiclo";
import Reportes from "modules/finops/conciliaciones/reportes";
import VipCame from "modules/came/vipCame";
import ComerciosJarvis from "modules/jarvis/comercios";
import Cerberus from "modules/monitoreo/cerberus";
import WhatsappJarvis from "modules/jarvis/whatsapp";
import CiclosAccespark from "modules/monitoreo/ciclosAccespark";
import Placas from "modules/monitoreo/placas";
import Camaras from "modules/monitoreo/camaras";
import Parking from "modules/noc/parking";
import Alertas from "modules/noc/alertas";
import Informe from "modules/came/informe";
import Tags from "modules/tags/envioTags";
import Facturas from "modules/financiera/facturas";
import Aseguramiento from "modules/financiera/aseguramiento";
import Bicicletas from "modules/came/bicicletas";
import Lazo from "modules/lazo";
import Edificio from "modules/copropiedades/semestrales";
import Administracion from "modules/copropiedades/adminUsuarios";
import Propiedades from "modules/copropiedades/adminPropiedades";
import Lotes from "modules/finops/conciliaciones/lotes";
import LotesFinanciera from "modules/finops/conciliaciones/lotesFinanciera";
import Permisos from "modules/copropiedades/permisos";
import Frecuencia from "modules/came/frecuencia";
import Permanencia from "modules/came/permanencia";
import UsoVip from "modules/came/usoVip";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import WhatsappCop from "modules/jarvis/copropiedadesW";
import EzytecCiclo from "modules/monitoreo/ezytecCiclo";
import ConfiguracionPeajes from "modules/finops/conciliaciones/ConfiguracionPeajes";

import navigation from "app/navigation/catalog";

const icons = {
  HomeIcon: <HomeIcon fontSize="small" />,
  HandymanIcon: <HandymanIcon fontSize="small" />,
  CalendarMonthIcon: <CalendarMonthIcon fontSize="small" />,
  AssignmentIcon: <AssignmentIcon fontSize="small" />,
  SettingsIcon: <SettingsIcon fontSize="small" />,
  LocalActivityIcon: <LocalActivityIcon fontSize="small" />,
  LockClockIcon: <LockClockIcon fontSize="small" />,
  WorkspacePremiumIcon: <WorkspacePremiumIcon fontSize="small" />,
  SummarizeIcon: <SummarizeIcon fontSize="small" />,
  PedalBikeIcon: <PedalBikeIcon fontSize="small" />,
  UpdateIcon: <UpdateIcon fontSize="small" />,
  HourglassEmptyIcon: <HourglassEmptyIcon fontSize="small" />,
  ApartmentIcon: <ApartmentIcon fontSize="small" />,
  LocationCityIcon: <LocationCityIcon fontSize="small" />,
  ManageAccountsIcon: <ManageAccountsIcon fontSize="small" />,
  HomeWorkIcon: <HomeWorkIcon fontSize="small" />,
  VpnKeyIcon: <VpnKeyIcon fontSize="small" />,
  LocalOfferIcon: <LocalOfferIcon fontSize="small" />,
  UploadFileIcon: <UploadFileIcon fontSize="small" />,
  AllInclusiveIcon: <AllInclusiveIcon fontSize="small" />,
  PublishIcon: <PublishIcon fontSize="small" />,
  AccountBalanceWalletIcon: <AccountBalanceWalletIcon fontSize="small" />,
  ReceiptLongIcon: <ReceiptLongIcon fontSize="small" />,
  SavingsIcon: <SavingsIcon fontSize="small" />,
  SpaceDashboardIcon: <SpaceDashboardIcon fontSize="small" />,
  StorefrontIcon: <StorefrontIcon fontSize="small" />,
  QueryStatsIcon: <QueryStatsIcon fontSize="small" />,
  CurrencyExchangeIcon: <CurrencyExchangeIcon fontSize="small" />,
  BusinessIcon: <BusinessIcon fontSize="small" />,
  FactCheckIcon: <FactCheckIcon fontSize="small" />,
  SettingsSuggestIcon: <SettingsSuggestIcon fontSize="small" />,
  PaidIcon: <PaidIcon fontSize="small" />,
  Inventory2Icon: <Inventory2Icon fontSize="small" />,
  AccountTreeIcon: <AccountTreeIcon fontSize="small" />,
  AssessmentIcon: <AssessmentIcon fontSize="small" />,
  ReportProblemIcon: <ReportProblemIcon fontSize="small" />,
  MarkEmailReadIcon: <MarkEmailReadIcon fontSize="small" />,
  CompareArrowsIcon: <CompareArrowsIcon fontSize="small" />,
  GarageIcon: <GarageIcon fontSize="small" />,
  AccountBalanceIcon: <AccountBalanceIcon fontSize="small" />,
  ShoppingCartIcon: <ShoppingCartIcon fontSize="small" />,
  ShoppingBagIcon: <ShoppingBagIcon fontSize="small" />,
  PinDropIcon: <PinDropIcon fontSize="small" />,
  ShoppingBasketIcon: <ShoppingBasketIcon fontSize="small" />,
  MuseumIcon: <MuseumIcon fontSize="small" />,
  TollIcon: <TollIcon fontSize="small" />,
  NorthIcon: <NorthIcon fontSize="small" />,
  GavelIcon: <GavelIcon fontSize="small" />,
  AltRouteIcon: <AltRouteIcon fontSize="small" />,
  CommuteIcon: <CommuteIcon fontSize="small" />,
  LocalCafeIcon: <LocalCafeIcon fontSize="small" />,
  NorthEastIcon: <NorthEastIcon fontSize="small" />,
  WaterIcon: <WaterIcon fontSize="small" />,
  ForestIcon: <ForestIcon fontSize="small" />,
  WavesIcon: <WavesIcon fontSize="small" />,
  MultipleStopIcon: <MultipleStopIcon fontSize="small" />,
  ForkRightIcon: <ForkRightIcon fontSize="small" />,
  TerrainIcon: <TerrainIcon fontSize="small" />,
  EastIcon: <EastIcon fontSize="small" />,
  WestIcon: <WestIcon fontSize="small" />,
  SailingIcon: <SailingIcon fontSize="small" />,
  DirectionsCarIcon: <DirectionsCarIcon fontSize="small" />,
  GridViewIcon: <GridViewIcon fontSize="small" />,
  AssuredWorkloadIcon: <AssuredWorkloadIcon fontSize="small" />,
  EngineeringIcon: <EngineeringIcon fontSize="small" />,
  PaletteIcon: <PaletteIcon fontSize="small" />,
  Looks3Icon: <Looks3Icon fontSize="small" />,
  PublicIcon: <PublicIcon fontSize="small" />,
  FlagIcon: <FlagIcon fontSize="small" />,
  MapIcon: <MapIcon fontSize="small" />,
  ExploreIcon: <ExploreIcon fontSize="small" />,
  BeachAccessIcon: <BeachAccessIcon fontSize="small" />,
  SouthIcon: <SouthIcon fontSize="small" />,
  ParkIcon: <ParkIcon fontSize="small" />,
  LandscapeTwoToneIcon: <LandscapeTwoToneIcon fontSize="small" />,
  HikingIcon: <HikingIcon fontSize="small" />,
  DirectionsBoatIcon: <DirectionsBoatIcon fontSize="small" />,
  WbTwilightIcon: <WbTwilightIcon fontSize="small" />,
  WaterDropIcon: <WaterDropIcon fontSize="small" />,
  SubwayIcon: <SubwayIcon fontSize="small" />,
  SouthEastIcon: <SouthEastIcon fontSize="small" />,
  AddRoadIcon: <AddRoadIcon fontSize="small" />,
  SpeedIcon: <SpeedIcon fontSize="small" />,
  GrassIcon: <GrassIcon fontSize="small" />,
  NatureIcon: <NatureIcon fontSize="small" />,
  StreamIcon: <StreamIcon fontSize="small" />,
  RouteIcon: <RouteIcon fontSize="small" />,
  BarChartIcon: <BarChartIcon fontSize="small" />,
  SupportAgentIcon: <SupportAgentIcon fontSize="small" />,
  NotificationsActiveIcon: <NotificationsActiveIcon fontSize="small" />,
  PolicyIcon: <PolicyIcon fontSize="small" />,
  LocalParkingIcon: <LocalParkingIcon fontSize="small" />,
  RadarIcon: <RadarIcon fontSize="small" />,
  RouterIcon: <RouterIcon fontSize="small" />,
  SensorsIcon: <SensorsIcon fontSize="small" />,
  VideocamIcon: <VideocamIcon fontSize="small" />,
  AutorenewIcon: <AutorenewIcon fontSize="small" />,
  EventRepeatIcon: <EventRepeatIcon fontSize="small" />,
  SyncIcon: <SyncIcon fontSize="small" />,
  ShieldIcon: <ShieldIcon fontSize="small" />,
  PinIcon: <PinIcon fontSize="small" />,
  SmartToyIcon: <SmartToyIcon fontSize="small" />,
  StoreIcon: <StoreIcon fontSize="small" />,
  WhatsAppIcon: <WhatsAppIcon fontSize="small" />,
  MarkChatUnreadIcon: <MarkChatUnreadIcon fontSize="small" />,
  SecurityIcon: <SecurityIcon fontSize="small" />,
  AdminPanelSettingsIcon: <AdminPanelSettingsIcon fontSize="small" />,
  PeopleAltIcon: <PeopleAltIcon fontSize="small" />,
  LoginIcon: <LoginIcon fontSize="small" />,
  PersonAddAlt1Icon: <PersonAddAlt1Icon fontSize="small" />,
};

const screens = {
  Dashboard: <Dashboard />,
  Schedule: <Schedule />,
  JobOrder: <JobOrder />,
  Configuracion: <Configuracion />,
  Cierre: <Cierre />,
  VipCame: <VipCame />,
  Informe: <Informe />,
  Bicicletas: <Bicicletas />,
  Frecuencia: <Frecuencia />,
  Permanencia: <Permanencia />,
  UsoVip: <UsoVip />,
  Edificio: <Edificio />,
  Administracion: <Administracion />,
  Propiedades: <Propiedades />,
  Permisos: <Permisos />,
  Tags: <Tags />,
  Lazo: <Lazo />,
  Facturas: <Facturas />,
  Aseguramiento: <Aseguramiento />,
  TableroSac: <TableroSac />,
  TableroGerencia: <TableroGerencia />,
  InfoConcesion: <InfoConcesion />,
  GestionConciliaciones: <GestionConciliaciones />,
  ConfiguracionPeajes: <ConfiguracionPeajes />,
  Lotes: <Lotes />,
  LotesFinanciera: <LotesFinanciera />,
  Reportes: <Reportes />,
  ReportesConciliaciones: (
    <Reportes reportId={12} reportName="Conciliations" title="Correos conciliaciones" />
  ),
  Conciliacion: <Conciliacion />,
  Chipichape: <Chipichape />,
  Vizcaya: <Vizcaya />,
  Zpp: <Zpp />,
  Holguines: <Holguines />,
  Fundadores: <Fundadores />,
  Accenorte: <Accenorte />,
  AlcaEnvigado: <AlcaEnvigado />,
  Altviales: <Altviales />,
  Alma: <Alma />,
  Autocafe: <Autocafe />,
  AutNordeste: <AutNordeste />,
  AutoRioMagdalena: <AutoRioMagdalena />,
  AutopistaUraba: <AutopistaUraba />,
  AutRioGrande: <AutRioGrande />,
  BtsConcesionario: <BtsConcesionario />,
  AutoviaNeivaGirardot: <AutoviaNeivaGirardot />,
  Coviandina: <Coviandina />,
  Covioriente: <Covioriente />,
  Covipacifico: <Covipacifico />,
  Devimar: <Devimar />,
  Devimed: <Devimed />,
  Devisab: <Devisab />,
  Findeter: <Findeter />,
  Iccu: <Iccu />,
  LaPintada: <LaPintada />,
  PacificoTres: <PacificoTres />,
  Panamericana: <Panamericana />,
  PeajesNacionales: <PeajesNacionales />,
  Pisa: <Pisa />,
  Pob: <Pob />,
  RutaalMar: <RutaalMar />,
  RutaAlSur: <RutaAlSur />,
  RutaDelCacao: <RutaDelCacao />,
  RutaDelValle: <RutaDelValle />,
  RutaMSierraMar: <RutaMSierraMar />,
  RutaPortuaria: <RutaPortuaria />,
  SabanaOcc: <SabanaOcc />,
  Sisga: <Sisga />,
  TunelDelOriente: <TunelDelOriente />,
  UnionDelSur: <UnionDelSur />,
  ViaDelNus: <ViaDelNus />,
  Via40Express: <Via40Express />,
  Viadelosllanos: <Viadelosllanos />,
  ViaMontesDeMaria: <ViaMontesDeMaria />,
  ViaRioPamplonita: <ViaRioPamplonita />,
  Yuma: <Yuma />,
  Indicadores: <Indicadores />,
  Alertas: <Alertas />,
  Parking: <Parking />,
  Redes: <Redes />,
  Readers: <Readers />,
  Camaras: <Camaras />,
  CrearCiclo: <CrearCiclo />,
  CiclosAccespark: <CiclosAccespark />,
  EzytecCiclo: <EzytecCiclo />,
  Cerberus: <Cerberus />,
  Placas: <Placas />,
  ComerciosJarvis: <ComerciosJarvis />,
  WhatsappJarvis: <WhatsappJarvis />,
  WhatsappCop: <WhatsappCop />,
  Rol: <Rol />,
  Usuario: <Usuario />,
  SignIn: <SignIn />,
  SignUp: <SignUp />,
};

const buildRoutes = (items) =>
  items.map(({ iconKey, componentKey, collapse, ...metadata }) => ({
    ...metadata,
    ...(iconKey ? { icon: icons[iconKey] } : {}),
    ...(componentKey ? { component: screens[componentKey] } : {}),
    ...(collapse ? { collapse: buildRoutes(collapse) } : {}),
  }));

const routes = buildRoutes(navigation);
export default routes;
